import qs from 'qs';
import { AxiosRequestConfig } from 'axios';
import instance, { CRM_REPORT_API_URL } from 'api';
import {
  IArea,
  ICriteriaRating,
  INpsDetail,
  IPartner,
  IPartnerRatingByPartner,
  IRealEstate,
  IRealEstateRatingByPartner,
  IServiceOrg,
  IServiceType,
} from './interfaces';

export const getPartnerRatingRealEstates = async (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IRealEstate[]>('/partner/rating/listRealEstate', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getPartnerRatingPartners = async (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IPartner[]>('/partner/rating/listPartner', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getPartnerRatingServiceOrgs = async (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IServiceOrg[]>('/partner/rating/listServiceOrg', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getPartnerRatingAreas = async (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IArea[]>('/partner/rating/listArea', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getServiceTypeListAllShowInRating = () => {
  return instance()
    .get<IServiceType[]>(`/serviceType/listAllShowInRating`)
    .then((response) => response.data);
};

export const getCriteriaRatingsByServiceType = async (serviceTypeId: number) => {
  return instance()
    .get<ICriteriaRating[]>(`/criteriaRating/listAllByServiceTypeId/${serviceTypeId}`)
    .then((response) => response.data);
};

export const getPartnerRatingByRealEstate = async (
  partnerGuid: string,
  realEstateGuid: string,
  config?: AxiosRequestConfig,
) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IRealEstateRatingByPartner[]>(`/partner/rating/listByPartner/${partnerGuid}/${realEstateGuid}`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getPartnerRatingByPartner = async (partnerGuid: string, config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IPartnerRatingByPartner>(`/partner/rating/listByPartner/${partnerGuid}`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getPartnerRatingByPartnerV2 = async (partnerGuid: string, config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IPartnerRatingByPartner>(`/partner/rating/v2/listByPartner/${partnerGuid}`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getPartnerRatingByRealEstateV2 = async (
  partnerGuid: string,
  realEstateGuid: string,
  config?: AxiosRequestConfig,
) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IRealEstateRatingByPartner[]>(`/partner/rating/v2/listByPartner/${partnerGuid}/${realEstateGuid}`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getPartnerRatingNpsDetail = async (
  realEstateGuid: string,
  date: string,
  config?: AxiosRequestConfig,
) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<INpsDetail | null>(`/partner/rating/v2/nps/${realEstateGuid}`, {
      ...config,
      params: { date, ...config?.params },
    })
    .then((response) => response.data || null);
};

export const exportPartnerRatingByPartnerExcel = async (partnerGuid: string, config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>(`/partner/rating/listByPartner/${partnerGuid}/export`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
      responseType: 'blob',
    })
    .then((response) => response.data);
};

export const exportPartnerRatingByRealEstateExcel = async (
  partnerGuid: string,
  realEstateGuid: string,
  config?: AxiosRequestConfig,
) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>(`/partner/rating/listByPartner/${partnerGuid}/${realEstateGuid}/export`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
      responseType: 'blob',
    })
    .then((response) => response.data);
};
